/** Trigger a browser download from an axios Blob response. */
export function downloadBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Revoke after a tick so Safari/iOS finishes the navigation
  setTimeout(() => window.URL.revokeObjectURL(url), 1000);
}

/** Open a Blob in a new tab (good for inline PDF preview on mobile). */
export function openBlob(blob) {
  const url = window.URL.createObjectURL(blob);
  window.open(url, "_blank", "noopener,noreferrer");
  setTimeout(() => window.URL.revokeObjectURL(url), 60000);
}

/** Today's date as YYYY-MM-DD (UTC) for filenames. */
export function todayStr() {
  return new Date().toISOString().slice(0, 10);
}
